import React from "react";

export const FrameworkComparisonChangesNotificationMessage = ({ content }) => (
  <div>
    Framework comparison finished.
    <br />
    {content.countOfChanges + " change(s) found."}
    {
      content.countOfChanges > 0
      ?
        <div>
          <br />
          Changes by entity type:
          <ul>
            {
              transformResultObjectToBulletPoint(content.countOfChangesByEntityType)
            }
          </ul>
          Changes by operation:
          <ul>
            {
              transformResultObjectToBulletPoint(content.countOfChangesByOperation)
            }
          </ul>
        </div>
      : null
    }
  </div>
);

const transformResultObjectToBulletPoint = (result) => {
  return Object.entries(result).map((entry, index) => {
    return (
      <li key={index}>
        {entry[0] + ": " + entry[1]}
      </li>
    )
  })
}